import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useViewlogies } from 'context';
import './contactUs.scss';
import { getCorrectedUrl } from '../../utils.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import PlantATree from '../Donations/PlantATree';

const refresh = () => window.location.reload(true);

const ContactUs = () => {
    const {
        event: { organizationName, color = '#000' },
        isMobile,
    } = useViewlogies();

    return (
        <section className="contact-us">
            <div className="contact-us-content">
                <h2 className="contact-heading" style={{ color }}>
                    <FormattedMessage
                        id="components.ContactUs.title"
                        defaultMessage="Need technical support or help with the video?"
                    />
                </h2>

                <ul className="support-checklist">
                    <li>
                        <FontAwesomeIcon icon={faCheck} className="icon" style={{ color }} />
                        <span>
                            <FormattedMessage
                                id="components.ContactUs.step1"
                                defaultMessage="First, try <a>refreshing</a> the website to reconnect the Private Broadcast™."
                                values={{
                                    a: chunks => (
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                window.location.reload();
                                            }}
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        </span>
                    </li>
                    <li>
                        <FontAwesomeIcon icon={faCheck} className="icon" style={{ color }} />
                        <span>
                            <FormattedMessage
                                id="components.ContactUs.step2"
                                defaultMessage="Visit our <a>Help Center</a>."
                                values={{
                                    a: chunks => <a href="https://www.viewlogies.com/help-center">{chunks}</a>,
                                }}
                            />
                        </span>
                    </li>
                    <li>
                        <FontAwesomeIcon icon={faCheck} className="icon" style={{ color }} />
                        <span>
                            <FormattedMessage
                                id="components.ContactUs.step3"
                                defaultMessage="Call or text our support team."
                            />
                        </span>
                    </li>
                </ul>

                <h2 className="contact-phone" style={{ color }}>
                    <a href="tel:4157638439" style={{ color, textDecoration: 'none' }}>
                        (415) 763-8439
                    </a>
                </h2>

                <a
                    className="contact-email-button"
                    href="mailto:support@viewlogies.com"
                    style={{ backgroundColor: color }}
                >
                    support@viewlogies.com
                </a>

                <p className="contact-footer-note">
                    <FormattedMessage
                        id="components.ContactUs.note"
                        defaultMessage="{1} video streaming and recording is powered by Viewlogies."
                        values={{ 1: organizationName }}
                    />
                </p>
            </div>

            {!isMobile && <PlantATree />}
        </section>
    );
};

export default ContactUs;
